import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Row,
  Col,
  Menu,
  Descriptions,
  Typography,
  Button,
  Grid,
  Input,
} from "antd";
import { ArrowLeftOutlined, SearchOutlined } from "@ant-design/icons";
import { useFetchApi } from "../../hooks/useFetchApi";
import DynamicMetricsTab from "./DynamicMetricsTab";
import { captialCase } from "../../helper";
import { BasicCard } from "../../components/Card";
import routes from "../../setup/routes";

const { useBreakpoint } = Grid;

const Stock: React.FC = (): React.ReactElement => {
  const params = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const screens = useBreakpoint();
  const [stock, setStockDetails] = useState<any>({});
  const [selectedTab, selectATab] = useState<string>("EPS");
  const [otherMetrics, setMetrics] = useState<Array<string>>([]);
  const [openModal, toggleModal] = useState<any>({ bulkUpload: false });
  const [bulkUploadName, setBulkUploadName] = useState<string>("");
  const [metricSearch, setMetricSearch] = useState<string>("");
  const { execute, response, loading } = useFetchApi(
    `/api/stocks/${params.id}`,
    {},
    "GET",
  );
  const {
    execute: getOtherMetrics,
    response: metrics = [],
    loading: metricsLoading,
  } = useFetchApi(`/api/metrics?hasTable=true`, {}, "GET");

  const toggle = (e: any, market?: any) => {
    const id = e.target.id.split("~");
    const type = id[0];
    const name = id[1];
    if (type && name) {
      toggleModal({ ...openModal, [type]: !openModal[type] });
      setBulkUploadName(name);
    }
  };

  const handleBack = () => {
    navigate(`${routes.DASHBOARD}/${routes.STOCK_LISTINGS}`, {
      state: { selectedMarket: location.state.selectedMarket },
    });
  };

  useEffect(() => {
    execute();
    getOtherMetrics();
  }, []);

  useEffect(() => {
    if (!loading && response) {
      setStockDetails(response);
    }
  }, [loading, response]);

  useEffect(() => {
    if (metrics && !metricsLoading) {
      setMetrics(metrics);
      // selectATab([...metrics][0]);
    }
  }, [metricsLoading, metrics]);

  const isMobile = !screens.md;

  const priceStats = [
    { label: "Open", value: `${stock.open ?? ""} ${stock.currency ?? ""}` },
    { label: "High", value: `${stock.high ?? ""} ${stock.currency ?? ""}` },
    { label: "Low", value: `${stock.low ?? ""} ${stock.currency ?? ""}` },
    {
      label: "Last traded price",
      value: `${stock.closed ?? ""} ${stock.currency ?? ""}`,
    },
    { label: "Volume traded", value: stock.volume },
    { label: "Change in perc", value: `${stock.change_perc ?? ""}%` },
    { label: "Change in amount", value: stock.change_in_amount },
    { label: "Total trades", value: stock.total_trades },
  ];

  const filteredMetrics = otherMetrics.filter((tab: string) =>
    captialCase(tab).toLowerCase().includes(metricSearch.trim().toLowerCase()),
  );

  const menuItems = filteredMetrics.map((tab: string) => ({
    key: tab,
    label: captialCase(tab),
  }));

  return (
    <div
      style={{
        padding: isMobile ? "16px" : "24px 48px",
        background: "#fff",
        minHeight: "100%",
      }}
    >
      {/* <BulkUploadModal name={bulkUploadName} data={selectedData}  status={openModal.bulkUpload} onClose={toggle} onSuccess={toggle}/> */}
      <div style={{ marginBottom: 16 }}>
        <Button
          icon={<ArrowLeftOutlined />}
          onClick={handleBack}
          type="primary"
        >
          Go Back
        </Button>
      </div>

      <BasicCard {...stock} />

      <Descriptions
        style={{ marginTop: 16 }}
        bordered
        size="small"
        column={{ xs: 1, sm: 2, md: 2 }}
      >
        {priceStats.map((stat) => (
          <Descriptions.Item key={stat.label} label={stat.label}>
            {stat.value}
          </Descriptions.Item>
        ))}
      </Descriptions>

      <Row gutter={[16, 16]} style={{ marginTop: 32 }}>
        <Col xs={24} md={6}>
          <Typography.Title level={4} style={{ fontWeight: 700 }}>
            Metrics
          </Typography.Title>
          <Input
            allowClear
            placeholder="Search metrics..."
            prefix={<SearchOutlined />}
            value={metricSearch}
            onChange={(e) => setMetricSearch(e.target.value)}
            style={{ marginBottom: 12 }}
          />
          <div
            style={{
              maxHeight: isMobile ? "auto" : 800,
              overflowY: isMobile ? "visible" : "auto",
              overflowX: isMobile ? "auto" : "visible",
            }}
          >
            <Menu
              mode={isMobile ? "horizontal" : "inline"}
              selectedKeys={[selectedTab]}
              items={menuItems}
              onClick={({ key }) => selectATab(key)}
              style={
                isMobile ? { display: "flex", flexWrap: "nowrap" } : undefined
              }
            />
          </div>
        </Col>

        <Col xs={24} md={18}>
          {otherMetrics.includes(selectedTab) && Object.keys(stock).length ? (
            <DynamicMetricsTab
              name={selectedTab}
              stock={stock}
              onSuccess={() => alert("updated successfully")}
            />
          ) : null}
        </Col>
      </Row>
    </div>
  );
};

export default Stock;
